<script>const startTokens = ["<|", "{{", "{%", "{#", "</"];
const endTokens = ["|>", "}}", "%}", "#}", "/>"];
const allTokens = [...startTokens, ...endTokens, "<=", "!=", ">=", ...startTokens, ...endTokens];
export let length = 10;
function makeLine(length2, lastLine = Array.from({ length: length2 }, () => "")) {
  const tokens = [];
  let thisToken = "";
  let lastToken = "";
  for (let i = 0; i < length2; i++) {
    while (thisToken === lastToken || thisToken === lastLine[i]) {
      let tokenSet;
      if (i === 0)
        tokenSet = startTokens;
      else if (i === length2 - 1)
        tokenSet = endTokens;
      else
        tokenSet = allTokens;
      thisToken = tokenSet[Math.floor(Math.random() * tokenSet.length)];
    }
    tokens.push(thisToken);
    lastToken = thisToken;
  }
  return tokens;
}
function makeSquare(length2) {
  const square2 = [];
  let lastLine = [];
  for (let i = 0; i < length2; i++) {
    const line = makeLine(length2, lastLine);
    square2.push(line);
    lastLine = line;
  }
  return square2;
}
const square = makeSquare(length);
export let isHighlighted = () => Math.random() < 0.15;
</script>

<div class="promplate-pattern-6rsabq">
  {#each square as line, y}
    <div class="promplate-pattern-ler60m">
      {#each line as token, x}
        <span class:promplate-pattern-tv0qqi={!isHighlighted({ x, y })}>{token}</span>
      {/each}
    </div>
  {/each}
</div>

<style>:global(.promplate-pattern-6rsabq){display:flex;flex-direction:column;-webkit-user-select:none;user-select:none;white-space:pre-wrap;font-weight:300;line-height:1.25;font-family:"Fira Code",ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;}:global(.promplate-pattern-ler60m){display:flex;flex-direction:row;}:global(.promplate-pattern-tv0qqi){opacity:0.1;}</style>